import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule,ToastMessageComponent],
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss', '../../../app.component.scss']
})
export class EditProfileComponent implements OnInit {
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;

  user: any = {};
  public isWebPermissions = "";
  public contactNumberCode = "+353";
  
  public stores = [];
  public selectedStores = [];
  selectedStoreName: string = ''; 
  public selectedStore: { 
    id: string|number,
    name: string
  } = {
    id: "",
    name: ""
  };

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    const userId = localStorage.getItem('userId');
    this.userService.getUserDetails(userId).subscribe((data: any) => {
      this.stores =(data.data.stores) ? data.data.stores : [];
      this.user = data.data;

      this.selectedStore = this.stores.find((store) => store.id == this.user.default_store_id);
      if(this.selectedStore)
        this.selectedStoreName = this.selectedStore.name;

    }, error => {
      console.error('Error fetching user details:', error);
    });
  }

  onStoreChange(store: any) {
    this.selectedStoreName = store.name;
    this.user.default_store_id = store.id;
  }

  openStoreDropdown(event){
    let popupDiv = document.getElementById("roles-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation();

        document.addEventListener('click', function(event: any) {
          if (
            popupDiv.className.includes("active")
          ) {
            popupDiv.classList.remove("active");
          } 
        })
      }
  }

  onSubmit(f: NgForm) {
    if (!this.user.user_id) {
      console.error('User ID is not defined.', this.user);
      return;
    }

    if (f.value.password === f.value.password_confirmation) {
      if (this.isWebPermissions) {
        let loggedUser = JSON.parse(localStorage.getItem('role'));
        f.value.resource_id = [loggedUser.resource_id];
      }

      if (f.value.contact_number !== "") {
        f.value.contact_number = this.contactNumberCode + " " + f.value.contact_number;
      }

      f.value.user_id = this.user.user_id; 
      f.value.first_name = this.user.first_name;
      f.value.last_name = this.user.last_name;
      f.value.email = this.user.email;
      f.value.username = this.user.username;
      f.value.contact_number = this.user.contact_number;
      f.value.default_store_id = (this.user.default_store_id) ? this.user.default_store_id : null;

      console.log('Submitting form with user ID:', this.user.user_id, f.value);
      console.log('Payload being sent:', f.value);

      this.userService.editProfileUser(this.user.user_id, f.value).subscribe({
        next: (data: any) => {
          console.log('Profile updated successfully');
          this.toastMessage.showToast("Profile has been successfully updated", "success");
        }, 
        error: (err) => {
          console.error('Error updating profile:', err);
          if (err.error) {
            console.error('Error details:', err.error);
          }
          this.toastMessage.showToast("Failed to update user", "error");
        }
      });
    } else {
      console.error('Passwords do not match.');
      this.toastMessage.showToast("Passwords do not match", "error");
    }
  }
}
